import { createContext, useContext, useEffect, useState } from "react";
import {
  getPublicContent,
  getPublicSettings,
  getPublicServices,
  getPublicCategories,
} from "../lib/store";
import {
  defaultContent,
  defaultSettings,
  defaultServices,
  defaultCategories,
} from "../lib/defaults";

const Ctx = createContext(null);
export const usePublicData = () => useContext(Ctx);

export function PublicDataProvider({ children }) {
  const [data, setData] = useState({
    content: defaultContent,
    settings: defaultSettings,
    services: defaultServices,
    categories: defaultCategories,
    loading: true,
  });

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const [content, settings, services, categories] = await Promise.all([
          getPublicContent(),
          getPublicSettings(),
          getPublicServices(),
          getPublicCategories(),
        ]);
        if (alive)
          setData({ content, settings, services, categories, loading: false });
      } catch {
        if (alive) setData((d) => ({ ...d, loading: false }));
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  return <Ctx.Provider value={data}>{children}</Ctx.Provider>;
}
